export default {
  settings: {
    title: 'Paramètres',
    account_related: 'Informations sur le compte',
    // user_related: "",
    add_user_title: 'Ajouter un utilisateur',
    edit_user_title: "Modifier l'utilisateur",
    label: {
      enabled: 'Activé',
      not_set: 'Non défini',
    },
    company: {
      title: "Informations sur l'entreprise",
      name: "Nom de l'entreprise",
      english_name: 'English name',
      scale: "Nombre d'employés",
      industry_type: "Secteur d'activité",
      plan: 'Plan',
      location: 'Adresse',
      allowed_ip: 'Adresses IP autorisées',
      mfa: 'Authentification par SMS',
      sales_amount: 'Revenu',
      country: 'Pays',
    },
    contract_plans: {
      buyer: "Plan de l'acheteur",
      supplier: 'Plan du fournisseur',
    },
    user: {
      title: 'Liste des utilisateurs',
      name: 'Nom',
      first_name: 'Nom',
      last_name: 'Prénom',
      email: 'Adresse e-mail',
      email_unverified: "Avant l'enregistrement",
      password: 'Mot de passe',
      password_protection: 'Caché pour des raisons de sécurité',
      phone_number: 'Numéro de téléphone',
      role: {
        title: 'Autorisation',
        admin: 'Administrateur',
        general: 'Général',
      },
      locale: 'Sélectionner la langue',
      action: 'Opération',
      total: 'Tout : {total}(Max : {max})',
    },
    button: {
      create: 'Ajouter un utilisateur',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '@:common.btn.update',
      delete: '@:common.btn.delete',
      do_delete: '@:common.btn.delete',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: 'Notification',
    cautions_01: 'Vous ne pouvez pas modifier votre adresse e-mail. Pour réinitialiser votre adresse e-mail, veuillez créer un nouvel utilisateur.',
    cautions_02: "Un numéro de téléphone est requis si l'authentification par SMS est activée.",
    cautions_03: "Pour réinitialiser votre mot de passe, veuillez saisir le code de vérification envoyé à votre adresse e-mail enregistrée dans l'écran de réinitialisation du mot de passe.",
    cautions_04: "La suppression d'un utilisateur n'entraîne pas la suppression des données de réponse ou de la carte de score.",
    messages: {
      user_update: "Mise à jour des informations sur l'utilisateur",
      user_delete: "Supprimer l'utilisateur",
      confirm_delete: 'Voulez-vous supprimer cet utilisateur ?',
      // complete_create: "",
      complete_update: "Les informations relatives à l'utilisateur ont été mises à jour.",
      complete_delete: "La suppression des informations sur l'utilisateur est terminée.",
      disabled_delete: 'Au moins un utilisateur doit être une autorité « Admin ».',
      disabled_delete_by_auth: "Seul l'administrateur peut le supprimer.",
      invalid_form: 'Entrée incorrecte.',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: "Après avoir cliqué sur « AJOUTER », un e-mail de confirmation sera envoyé à l'adresse e-mail que vous avez indiquée. \nPar la suite, un e-mail contenant votre identifiant et votre mot de passe vous sera envoyé.",
      caution_two: "Un numéro de téléphone est requis si l'authentification par SMS est activée.",
      caution_three: "Il est possible d'ajouter jusqu'à 5 utilisateurs.",
      user_add_title: 'Ajouter un utilisateur',
      user_add_message_one: "Nous avons envoyé un e-mail à l'adresse que vous avez indiquée. ",
      user_add_message_two: 'Veuillez vérifier votre e-mail et suivre les instructions qui y figurent pour vous connecter.',
    },
    tips: {
      role: "L'autorité « Admin » peut ajouter et supprimer des utilisateurs, mais pas l'autorité « Général ».",
      locale: 'Vous pouvez sélectionner la langue initiale après la connexion.',
    },
    // english_name_edit_modal_title: "",
    // english_name_input_label: "",
    // english_name_placeholder: "",
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: "Voulez-vous vraiment vous déconnecter et aller sur la page de réinitialisation du mot de passe ? Sur la page de réinitialisation du mot de passe, veuillez saisir le code de vérification fourni dans l'e-mail envoyé à votre adresse e-mail enregistrée.",
      reset: 'Réinitialiser le mot de passe',
    },
  },
}
